"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropdownButton = void 0;
var React = require("react");
var Keyboard_1 = require("../../../_Core/Keyboard");
var ChevronDownIcon_1 = require("../../../Icons/Assets/ChevronDownIcon");
var Localization_1 = require("../../../Localization");
var ChartRangeDropdownPicker_context_1 = require("../ChartRangeDropdownPicker.context");
var ChartRangeDropDownPicker_styles_1 = require("../ChartRangeDropDownPicker.styles");
var DropdownButton = function () {
    var dispatch = ChartRangeDropdownPicker_context_1.useDispatchContext().dispatch;
    var _a = ChartRangeDropdownPicker_context_1.useStateContext(), isDropdownOpen = _a.isDropdownOpen, hasCompareRange = _a.hasCompareRange;
    var _b = ChartRangeDropdownPicker_context_1.useChartRangeDropdownPicker(), DateRangeCaption = _b.DateRangeCaption, CompareRangeCaption = _b.CompareRangeCaption;
    var handleOnClick = function () { return dispatch({ type: "openDropdown" }); };
    var handleOnKeyDown = function (e) {
        if ((Keyboard_1.IsDownArrow(e)) && !isDropdownOpen) {
            e.nativeEvent.stopImmediatePropagation();
            e.preventDefault();
            dispatch({ type: "openDropdown" });
        }
        else if (Keyboard_1.IsEscape(e)) {
            e.nativeEvent.stopImmediatePropagation();
            e.preventDefault();
            dispatch({ type: "cancel" });
        }
    };
    return (React.createElement(ChartRangeDropDownPicker_styles_1.ControlWrapperDiv, { role: "button", tabIndex: 0, "aria-haspopup": "listbox", "aria-expanded": isDropdownOpen, onKeyDown: handleOnKeyDown, onClick: handleOnClick },
        hasCompareRange && CompareRangeCaption ? (React.createElement(ChartRangeDropDownPicker_styles_1.LabelWrapperDiv, null,
            React.createElement(ChartRangeDropDownPicker_styles_1.ValueTextDiv, null, DateRangeCaption),
            React.createElement(ChartRangeDropDownPicker_styles_1.CompareTextDiv, null, Localization_1.strings.formatString(Localization_1.strings.ChartRangeDropDownPicker_Message_CompareTo, CompareRangeCaption)))) :
            (React.createElement(ChartRangeDropDownPicker_styles_1.SingleValueTextDiv, null, DateRangeCaption)),
        React.createElement(ChartRangeDropDownPicker_styles_1.IconWrapperDiv, null,
            React.createElement(ChevronDownIcon_1.ChevronDownIcon, null))));
};
exports.DropdownButton = DropdownButton;
